
























































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import App from "../App.vue";
import axios from "axios";
import { ProductVersionData } from "../models/ProductVersionData";
import ErrorDialog from "./ErrorDialog.vue";
import RowActions from "./RowActions.vue";
import ChangesLogTable from "./ChangesLogTable.vue";
import { EnumHelpers, LicensingType, LogType } from "../helpers/EnumHelpers";
import { DateHelpers } from "../helpers/DateHelpers";
import { ErrorHandlingHelpers } from "../helpers/ErrorHandlingHelpers";
import { FailureResponseData } from "../models/FailureResponseData";
import { ChangeLogEntryData } from "../models/ChangeLogEntryData";
import { ToolData } from "../models/ToolData";
import { ToolDataList } from "../models/ToolDataList";
import { ProductDataList } from "../models/ProductDataList";
import { ProductToolData } from "../models/ProductToolData";
import ValidationErrorsCard from "./ValidationErrorsCard.vue";
import ActionsCard from "./ActionsCard.vue";
import TitleCard from "./TitleCard.vue";
import { ToolVersionData } from "../models/ToolVersionData";

@Component({
  components: {
    RowActions,
    ErrorDialog,
    ChangesLogTable,
    ValidationErrorsCard,
    ActionsCard,
    TitleCard,
  },
})
export default class ProductVersionDialog extends App {
  get getTitle() {
    if (this.isValidEdit()) {
      return "Edit Product Version " + this.item.name;
    } else if (this.isValidDuplication()) {
      return "Duplicate Product Version " + this.item.name;
    } else {
      return "Create New Product Version";
    }
  }
  @Prop({ default: false })
  public isShown!: boolean;
  @Prop({ default: false })
  public isEdit!: boolean;
  @Prop({ default: false })
  public isDuplication!: boolean;
  @Prop({ required: false })
  public item!: ProductVersionData;
  @Prop({ required: true })
  public ownerId!: string;

  private types: string[] = EnumHelpers.GetLicensingTypes();
  private toolNames: Array<object> = [];
  private tools: ToolData[] = [];

  private privateIsShown: boolean = false;
  private errorDialogIsShown: boolean = false;
  private dateMenuShown: boolean = false;
  private failure: FailureResponseData = new FailureResponseData();

  private name: string = "";
  private minSupportedVersion: string = "";
  private maxSupportedVersion: string = "";
  private publishedUTC: string = "";
  private selectedSupportedLicensingTypes: string[] = [];
  private licensingId: string = "";
  private visible: boolean = true;
  private msrp: string = "";
  private selectedTools: Array<object> = [];
  private changeLog: ChangeLogEntryData[] = [];
  private fullChangeLogs: Array<object> = [];
  private originalChangeLog: ChangeLogEntryData[] = [];
  private latest: boolean = false;
  private latestChanged: boolean = false;
  private singleUserInstallerUri: string = "";
  private multiUserInstallerUri: string = "";

  @Watch("isShown")
  public onIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    this.privateIsShown = value;
  }
  @Watch("privateIsShown")
  public onprivateIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    if (value) {
      this.fetchProductVersion();
    } else {
      this.$emit("dialogClosed");
      this.loading = true;
    }
  }
  @Watch("selectedTools")
  public onSelectedToolsChange(value: Array<object>) {
    const stateProductVersionTools: Array<object> = [];
    value.forEach((st) => {
      const tool = this.toolNames.filter(
        (t) => t.uniqueName === st.uniqueName || t.uniqueName === st
      )[0];
      if (tool) {
        stateProductVersionTools.push(tool);
      }
    });
    this.$store.state.productVersionTools = stateProductVersionTools;
  }

  public isLatestChanged(e) {
    this.latestChanged = true;
  }

  public async commitChanges() {
    if (!this.checkForm()) {
      return;
    }
    this.loading = true;
    try {
      const updatedTools: ProductToolData[] = [];
      let displayOrder: number = 1;
      this.selectedTools.forEach((st) => {
        const toolData = this.tools.filter(
          (t) => t.uniqueName === st.uniqueName || t.uniqueName === st
        )[0];
        if (toolData) {
          updatedTools.push(new ProductToolData(toolData.id, displayOrder++));
        }
      });

      const res: ProductVersionData = new ProductVersionData(
        this.name,
        this.minSupportedVersion,
        this.maxSupportedVersion,
        DateHelpers.convertToDate(this.publishedUTC),
        this.changeLog,
        "",
        this.ownerId,
        this.originalChangeLog,
        EnumHelpers.GetFlaggedLicensingTypesValue(
          this.selectedSupportedLicensingTypes
        ),
        Number(this.licensingId),
        !this.visible,
        Number(this.msrp),
        updatedTools,
        this.latest,
        this.singleUserInstallerUri,
        this.multiUserInstallerUri
      );

      let errorObject: FailureResponseData = new FailureResponseData();
      let errorsOccurred: boolean = false;

      let resp;

      if (this.isValidEdit()) {
        resp = await axios
          .put<ProductVersionData>(`ProductVersions/${this.item.id}`, res)
          .catch((error) => {
            errorsOccurred = true;
            errorObject = ErrorHandlingHelpers.getFailureMessage(error);
          });
      } else if (this.isValidDuplication()) {
        resp = await axios
          .post<ProductVersionData>(
            `ProductVersions/duplicate/${this.item.id}`,
            res
          ) // can use the same data object, only the relevant fields will be used.
          .catch((error) => {
            errorsOccurred = true;
            errorObject = ErrorHandlingHelpers.getFailureMessage(error);
          });
      } else {
        resp = await axios
          .post<ProductVersionData>(`ProductVersions`, res)
          .catch((error) => {
            errorsOccurred = true;
            errorObject = ErrorHandlingHelpers.getFailureMessage(error);
          });
      }

      if (errorsOccurred) {
        this.failure = errorObject;
        this.errorDialogIsShown = true;
      } else {
        if (this.isValidEdit()) {
          this.$emit("editVersion", this.item, resp.data);
        } else {
          // new or duplication
          this.$emit("addVersion", resp.data);
        }
        this.privateIsShown = false;
      }
    } catch (e) {
      this.failure = new FailureResponseData(e.message);
      this.errorDialogIsShown = true;
    }

    this.loading = false;
  }

  public cancelled(item) {
    this.privateIsShown = false;
    this.$emit("dialogCancelled");
  }

  private setDefaultData() {
    this.validationErrors = [];
    this.name = "";
    this.minSupportedVersion = (new Date().getUTCFullYear() - 3).toString();
    this.maxSupportedVersion = (new Date().getUTCFullYear() + 1).toString();
    this.publishedUTC = DateHelpers.getTodaysDate();
    this.selectedSupportedLicensingTypes = [];
    this.licensingId = "";
    this.visible = false;
    this.msrp = "";
    this.changeLog = [];
    this.fullChangeLogs = [];
    this.selectedTools = [];
    this.resetValidation();
    this.latest = false;
    this.singleUserInstallerUri = "";
    this.multiUserInstallerUri = "";
  }

  private isValidEdit() {
    return this.isEdit && this.item != null;
  }
  private isValidDuplication() {
    return this.isDuplication && this.item != null;
  }

  private checkForm() {
    this.validationErrors = [];

    const form: any = this.$refs.form;
    if (form) {
      return form.validate();
    } else {
      if (!this.name) {
        this.validationErrors.push("Name is required.");
      }
      if (!this.minSupportedVersion) {
        this.validationErrors.push("Min supported version is required.");
      }
      if (!this.maxSupportedVersion) {
        this.validationErrors.push("Max supported version is required.");
      }
      if (!this.publishedUTC) {
        this.validationErrors.push("Published date is required.");
      }

      if (!this.isDuplication) {
        if (this.selectedSupportedLicensingTypes.length === 0) {
          this.validationErrors.push(
            "At least one licensing type is required."
          );
        }

        if (!this.licensingId) {
          this.validationErrors.push("Licensing id is required.");
        } else if (
          isNaN(Number(this.licensingId)) ||
          Number(this.licensingId) < 0
        ) {
          this.validationErrors.push(
            "Licensing id must be a valid non-negative number."
          );
        }

        if (!this.msrp) {
          this.validationErrors.push("The MSRP is required.");
        } else if (isNaN(Number(this.msrp)) || Number(this.msrp) < 0) {
          this.validationErrors.push(
            "The MSRP must be a valid non-negative number."
          );
        }
      }
      return this.validationErrors.length === 0;
    }
  }

  private logEntryAdded(logItem) {
    this.changeLog.push(
      new ChangeLogEntryData(
        logItem.type,
        logItem.description,
        logItem.toolId === undefined ? null : logItem.toolId,
        logItem.toolName === undefined ? null : logItem.toolName
      )
    );
    this.fullChangeLogs.push({
      type: EnumHelpers.GetLogType(logItem.type, false),
      description: logItem.description,
      name: logItem.toolName === undefined ? null : logItem.toolName,
    });
  }

  private logEntryEdited(oldLogItem, newLogItem) {
    this.logEntryRemoved(oldLogItem);
    this.logEntryAdded(newLogItem);
  }

  private logEntryRemoved(logItem: ChangeLogEntryData) {
    const typeName = EnumHelpers.GetLogType(logItem.type, false);
    const tool = this.toolNames.find((t) => t.name === logItem.toolName);
    if (!tool) {
      const changeLogtoRemove = this.changeLog.find(
        (cl) => cl.description == logItem.description && cl.type == logItem.type
      );
      this.changeLog = this.changeLog.filter((cl) => cl !== changeLogtoRemove);

      const fullchangeLogtoRemove = this.fullChangeLogs.find(
        (cl) => cl.description == logItem.description && cl.type == typeName
      );
      this.fullChangeLogs = this.fullChangeLogs.filter(
        (cl) => cl !== fullchangeLogtoRemove
      );
    } else {
      const changeLogtoRemove = this.changeLog.find(
        (cl) => cl.toolId == tool.id
      );
      this.changeLog = this.changeLog.filter((cl) => cl !== changeLogtoRemove);

      const fullchangeLogtoRemove = this.fullChangeLogs.find(
        (cl) =>
          cl.description == logItem.description &&
          cl.type == typeName &&
          cl.name == logItem.toolName
      );
      this.fullChangeLogs = this.fullChangeLogs.filter(
        (cl) => cl !== fullchangeLogtoRemove
      );
    }
  }

  private updateUniqueName(toolData: ToolData) {
    toolData.uniqueName = `${toolData.name} (${EnumHelpers.GetProductOrToolType(
      toolData.type,
      false
    )})`;
  }

  private async fetchProductVersion() {
    try {
      this.setDefaultData();

      // populate the tools
      this.toolNames = [];
      this.tools = [];
      const toolsResp = await axios.get<ToolDataList>("Tools", {
        params: {
          count: 1000,
          skip: 0,
        },
      });
      this.tools = toolsResp.data.items;
      this.tools.forEach((t) => {
        this.updateUniqueName(t);
        this.toolNames.push(t);
      });

      if (this.isValidEdit() || this.isValidDuplication()) {
        const resp = await axios.get<ProductVersionData>(
          `ProductVersions/withlatest/${this.item.id}`
        );

        this.name = resp.data.name;
        this.minSupportedVersion = resp.data.minSupportedVersion;
        this.maxSupportedVersion = resp.data.maxSupportedVersion;

        this.msrp = resp.data.msrp.toString();
        this.selectedSupportedLicensingTypes = EnumHelpers.GetFlaggedLicensingTypes(
          resp.data.supportedLicensingTypes
        );
        this.licensingId = resp.data.licensingId.toString();
        if (this.isValidDuplication()) {
          this.publishedUTC = "";
          this.changeLog = [];
          this.fullChangeLogs = [];
          this.originalChangeLog = [];
        } else {
          this.publishedUTC = DateHelpers.convertToString(
            new Date(resp.data.publishedUTC)
          );
          this.changeLog = resp.data.changeLog;
          this.fullChangeLogs = resp.data.fullChangeLogs;
          this.originalChangeLog = resp.data.originalChangeLog;
        }
        this.singleUserInstallerUri = resp.data.singleInstallerUri;
        this.multiUserInstallerUri = resp.data.multiInstallerUri;
        this.visible = !resp.data.hidden;
        this.latest = resp.data.latest;
        resp.data.tools.forEach((td) => {
          // the tools are tooldata, not producttooldata
          const toolData = this.tools.filter((t) => t.id === td.id)[0];
          if (toolData) {
            this.selectedTools.push(toolData);
          }
        });
      }
    } catch (e) {
      this.showError = true;
      this.errorMessage = `Error while loading product version data: ${
        e.message
      }.`;
    }
    this.loading = false;
  }

  private async created() {}
}
